import React from "react";
import { useAdminContext } from "../provider/AdminContext";
import DrilldownHeader from "./DrilldownHeader";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const ProjectsGrid = () => {
  const { selectedCompany, companyProjects, openProjectWorkflows } =
    useAdminContext();

  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="bg-gray-50 p-3 sm:p-4 md:p-6">
        <div className="max-w-5xl mx-auto">
          <DrilldownHeader
            title="Projects"
            breadcrumbs={["All Companies", selectedCompany?.companyName]}
          />

          {companyProjects.length === 0 ? (
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8 text-center text-sm text-gray-500">
              No projects found for this company.
            </div>
          ) : (
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {companyProjects.map((project) => (
                <div
                  key={project._id}
                  onClick={() => openProjectWorkflows(project)}
                  className="bg-white rounded-lg shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow cursor-pointer"
                >
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    {project.projectName}
                  </h2>
                  <p className="text-sm text-gray-500">
                    Created by:{" "}
                    {project.createdBy
                      ? `${project.createdBy.firstName} ${project.createdBy.lastName}`
                      : "N/A"}
                  </p>
                  <p className="text-sm text-gray-500 mt-1">
                    Created: {formatDate(project.createdAt)}
                  </p>
                  <span className="inline-block mt-3 px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                    {project.workflowsCount ?? 0} Workflows
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsGrid;
